import { useContext } from "react";
import { GlobalContext, GlobalContextType } from "./GlobalContextProvider";

export function useColorContext() {
  const { colors } = useContext<GlobalContextType>(GlobalContext);
  return colors;
}
